import { render, staticRenderFns } from "./u-swiper-pagination-outlined.vue?vue&type=template&id=e0f22174&scoped=true"
import script from "./u-swiper-pagination-outlined.vue?vue&type=script&lang=js"
export * from "./u-swiper-pagination-outlined.vue?vue&type=script&lang=js"
import style0 from "./u-swiper-pagination-outlined.vue?vue&type=style&index=0&id=e0f22174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f22174",
  null
  
)

export default component.exports